/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import TaktArea from '@/components/ProjectTaktPlan/TaktArea.component.vue';

export const TaktAreaMixin = {
  components: {
    TaktArea,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('TaktArea', [
      'getTaktarea',
      'getTaktareas',
      'getTaktareaLength',
      'getMoveTaktareaStartVariables',
    ]),
  },
  methods: {
    ...mapActions('TaktArea', [
      'changeTaktAreaStartBulk',

      // 'setTaktareaStart',
      'setMoveTaktareaStartVariables',
      // 'taktareaChangeValue',
      'tWaggonChangePosition',
      'tWaggonDelete',
      'tWaggonInsert'
    ]),
    ...mapActions('Ultra', [
      'updateUObject'
    ]),
    ...mapActions('View', [
      'setValue'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarUpdateTaktareaStart'
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookup'
    ]),
    moveTaktareaStartMouseDown(payload) {
      this.$refs[`taktarea${payload.taktarea_id}`][0].$el.style.width =
        `${this.$refs[`taktarea${payload.taktarea_id}`][0].$el.clientWidth + window.innerWidth}px`;
      this.setMoveTaktareaStartVariables({
        initial_x: payload.evt.pageX,
        train_id: payload.train_id,
        taktarea_id: payload.taktarea_id,
        initial_width: this.$refs[`placeholder_taktareastart_${payload.taktarea_id}`][0].$el.clientWidth,
        move_taktarea_start: true,
      }
    );
    },
    moveTaktareaStartMouseUp() {
      this.draggable_disabled = false;
      if (this.getMoveTaktareaStartVariables.move_taktarea_start === true) {
        this.setMoveTaktareaStartVariables({move_taktarea_start: false});
      let taktplan_zoom = getComputedStyle(document.body).getPropertyValue('--taktplan_zoom');
      let waggon_width_string = getComputedStyle(document.body).getPropertyValue('--waggon_width');
      let waggon_width = parseInt(waggon_width_string.substring(0, waggon_width_string.length-2)) + parseInt(4);
      // let new_taktarea_start = Math.round(this.$refs[`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`][0].$el.clientWidth / (waggon_width * taktplan_zoom));
      let new_taktarea_start = Math.round(document.getElementById(`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`).clientWidth / (waggon_width * taktplan_zoom));
      if (new_taktarea_start * (waggon_width * taktplan_zoom) === this.getMoveTaktareaStartVariables.initial_width) {
        // if (this.$refs[`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`][0].$el.clientWidth < this.getMoveTaktareaStartVariables.initial_width) {
        if (document.getElementById(`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`).clientWidth < this.getMoveTaktareaStartVariables.initial_width) {
          new_taktarea_start--;
        } else {
          new_taktarea_start++;
        }
      }
      this.setValue({key: 'taktarea_dragging', value: false});
      this.requestSnackbarUpdateTaktareaStart({
        url: [
          {projects: this.project_id},
          {trains: this.getMoveTaktareaStartVariables.train_id},
          {taktareas: this.getMoveTaktareaStartVariables.taktarea_id},
        ],
        update: {
          taktarea_start: new_taktarea_start
        }
      }).then((payload) => {
        this.updateUObject(payload).then(() => {
          this.updateCalenderLookup(this.project_id).then(() => {
            // this.$refs[`taktarea${this.getMoveTaktareaStartVariables.taktarea_id}`][0].$el.style.width =
            document.getElementById(`taktarea${this.getMoveTaktareaStartVariables.taktarea_id}`).style.width =
            `calc((${this.getProjectLength(this.project_id) + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom))`;
          });
        });
      });
      }
    },
    moveTaktareaStartMouseMove(evt) {
      if (this.getMoveTaktareaStartVariables.move_taktarea_start) {
        let difference_x = evt.pageX - this.getMoveTaktareaStartVariables.initial_x;
        // this.$refs[`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`][0].$el.style.width = `${this.getMoveTaktareaStartVariables.initial_width + difference_x}px`;
        document.getElementById(`placeholder_taktareastart_${this.getMoveTaktareaStartVariables.taktarea_id}`).style.width = `${this.getMoveTaktareaStartVariables.initial_width + difference_x}px`;
      }
    },
    onintersect(entries, observer, isIntersecting) {
      if (isIntersecting === false) {
        entries[0].target.children[5].style.display = "none";
      } else {
        entries[0].target.children[5].style.display = "flex";
      }
    },
    getTaktareasForCreateBulk(count, start, position, direction) {
      let taktareas = [];
      for (let i = 0; i < count; i++) {
        taktareas.push({
          taktarea_start: start + direction + i,
          position: position + direction + i,
        });
      }
      return taktareas;
    }
  }
};
